var _defs, _rect, _g, _path, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _path3, _rect8, _rect9, _rect10, _path4, _rect11, _rect12, _rect13, _path5, _rect14, _rect15, _rect16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmRanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-ranking-nm-cls-1 {\n        clip-path: url(#dummy-widget-ranking-nm-clippath);\n      }\n\n      .dummy-widget-ranking-nm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-ranking-nm-cls-2, .dummy-widget-ranking-nm-cls-3, .dummy-widget-ranking-nm-cls-4, .dummy-widget-ranking-nm-cls-5, .dummy-widget-ranking-nm-cls-6 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-ranking-nm-cls-3 {\n        fill: #4a494a;\n      }\n\n      .dummy-widget-ranking-nm-cls-4 {\n        fill: #393a3a;\n      }\n\n      .dummy-widget-ranking-nm-cls-7 {\n        fill: #1e1e1e;\n        stroke: #2b2b2b;\n        stroke-miterlimit: 10;\n        stroke-width: .4px;\n      }\n\n      .dummy-widget-ranking-nm-cls-5 {\n        fill: #3663ac;\n      }\n\n      .dummy-widget-ranking-nm-cls-6 {\n        fill: #1f1f1f;\n        isolation: isolate;\n        opacity: .7;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-ranking-nm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-2",
    x: 7.4,
    y: 7.6,
    width: 155.1,
    height: 155.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-4",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-ranking-nm-cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-6",
    x: 145.1,
    y: 7.6,
    width: 101.3,
    height: 70.8,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-6",
    x: 145.1,
    y: 91.5,
    width: 101.3,
    height: 70.5,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-6",
    x: -72.8,
    y: 7.6,
    width: 98.2,
    height: 155.1,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-nm-cls-7",
    d: "M44.7,8h81.1c3.4,0,6.1,2.7,6.1,6.1v142.1c0,3.3-2.7,6.1-6.1,6.1H44.7c-3.4,0-6.1-2.7-6.1-6.1V14.1c0-3.3,2.7-6.1,6.1-6.1Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-nm-cls-5",
    d: "M51.5,29.7h-1.6v-5.1l-1.6.5v-1.2l3.1-1.1h0v7h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 20,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 112.7,
    y: 20,
    width: 9.3,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 28.7,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-nm-cls-5",
    d: "M52.8,58.2h-4.9v-1.1l2.2-2.3c.6-.6.8-1.1.8-1.5s0-.5-.2-.7-.3-.2-.6-.2-.4,0-.6.3c-.2.2-.2.5-.2.8h-1.6c0-.4,0-.8.3-1.2s.5-.6.9-.8.8-.3,1.3-.3c.8,0,1.3.2,1.7.5s.6.8.6,1.5,0,.5-.2.8c0,.3-.3.5-.5.8s-.6.7-1,1.1l-.9,1h2.7v1.2h.2Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 48.6,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 112.7,
    y: 48.6,
    width: 9.3,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 57.3,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-nm-cls-5",
    d: "M49.4,83.7h.8c.6,0,.9-.3.9-.9s0-.4-.2-.6c0,0-.3-.2-.6-.2s-.4,0-.6.2c-.2,0-.2.3-.2.5h-1.6c0-.4,0-.7.3-1s.5-.5.8-.7.8-.2,1.2-.2c.8,0,1.4.2,1.8.5.4.4.7.8.7,1.5s0,.6-.3.8-.5.5-.8.6c.4,0,.7.3.9.6.2.3.3.6.3,1,0,.6-.2,1.1-.7,1.5s-1.1.6-1.9.6-.9,0-1.3-.3c-.4-.2-.7-.4-.9-.7-.2-.3-.3-.7-.3-1h1.6c0,.2,0,.4.3.6.2.2.4.2.6.2s.5,0,.7-.2.3-.4.3-.6c0-.4,0-.6-.3-.7s-.4-.2-.7-.2h-.8v-1.2h0Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 77.1,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 112.7,
    y: 77.1,
    width: 9.3,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 85.8,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-nm-cls-5",
    d: "M52.2,113.6h.7v1.2h-.7v1.5h-1.6v-1.5h-2.7v-1l2.7-4.5h1.6v4.2h0ZM49.4,113.6h1.3v-2.1.2c0,0-1.3,2-1.3,2h0Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 105.6,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 112.7,
    y: 105.6,
    width: 9.3,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 114.3,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-ranking-nm-cls-5",
    d: "M48.1,141.5l.4-3.6h4.1v1.3h-2.8l-.2,1.4c0,0,.3-.1.5-.2h.5c.7,0,1.2.2,1.6.6.4.4.6,1,.6,1.7s0,.8-.3,1.2c-.2.4-.5.6-.8.8-.4.2-.8.3-1.3.3s-.8,0-1.2-.3c-.4-.2-.7-.4-.9-.7s-.3-.7-.3-1.1h1.6c0,.3,0,.5.2.6,0,.1.3.2.6.2.5,0,.8-.4.8-1.2s-.3-1.1-1-1.1-.7.1-.8.4l-1.3-.3h0Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 134.2,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 112.7,
    y: 134.2,
    width: 9.3,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-ranking-nm-cls-3",
    x: 56.6,
    y: 142.9,
    width: 38.2,
    height: 5.3,
    rx: 2.4,
    ry: 2.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmRanking);
export default __webpack_public_path__ + "static/media/nm_ranking.f5bd0bc2.svg";
export { ForwardRef as ReactComponent };